import React from "react";
import "../componentsStyle.scss";
import { Form, Input, Button } from "antd";
import { sendFormToWhatsApp } from "../../helpers/Helper";

const { TextArea } = Input;

export const ContactForm = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    sendFormToWhatsApp(values);
  };

  return (
    <div className="contactForm">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="contact-form"
      >
        {/* Name */}
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter your name",
            },
          ]}
        >
          <Input placeholder="Enter your name" size="large" />
        </Form.Item>

        {/* Email */}
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter your email",
            },
            {
              type: "email",
              message: "Enter a valid email",
            },
          ]}
        >
          <Input placeholder="Enter your email" size="large" />
        </Form.Item>

        {/* Subject */}
        <Form.Item
          label="Subject"
          name="subject"
          rules={[
            {
              required: true,
              message: "Please enter a subject",
            },
          ]}
        >
          <Input placeholder="Enter subject" size="large" />
        </Form.Item>

        {/* Message */}
        <Form.Item
          label="Message"
          name="message"
          rules={[
            {
              required: true,
              message: "Please enter your message",
            },
          ]}
        >
          <TextArea rows={4} placeholder="Write your message..." />
        </Form.Item>

        {/* Submit */}
        <Form.Item>
          <Button
            className={`primary-button`}
            type="primary"
            htmlType="submit"
            size="large"
            block
          >
            Send Message
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
